export default __webpack_public_path__ + "static/media/eraser.269c86e6.svg";